import Controller from '@ember/controller';
import { set, computed, action } from '@ember/object';
import { task, timeout } from 'ember-concurrency';
import { inject as iService } from '@ember/service';
import { inject as iController } from '@ember/controller';

export default class FormController extends Controller {
  @iService session;
  @iService router;
  @iController('application') applicationController;

  queryParams = ['steps', 'step', 'from_checkin'];
  steps = null;
  step = 0;
  from_checkin = null;

  @computed('steps')
  get parsedSteps() {
    if (!this.steps) return [];
    return this.steps.split(',').map((s, i) => {
      const [type, id] = s.trim().split(':');
      return { index: i, type, id: id || null };
    });
  }

  @computed('step', 'parsedSteps.[]')
  get currentStepIndex() {
    const idx = parseInt(this.step, 10);
    const max = this.parsedSteps.length;
    return isNaN(idx) ? 0 : Math.max(0, Math.min(idx, max));
  }

  @computed('currentStepIndex', 'parsedSteps.[]')
  get done() {
    return this.parsedSteps.length > 0 && this.currentStepIndex >= this.parsedSteps.length;
  }

  @computed('parsedSteps.[]', 'currentStepIndex')
  get currentStep() {
    return this.parsedSteps[this.currentStepIndex] || null;
  }

  @computed('parsedSteps.[]', 'currentStepIndex')
  get isLastStep() {
    return this.currentStepIndex >= this.parsedSteps.length - 1;
  }

  @computed('parsedSteps.[]')
  get totalSteps() {
    return this.parsedSteps.length;
  }

  @computed('parsedSteps.[]')
  get stepNames() {
    const labels = { dati: 'Dati', modulo: 'Modulo', project: 'Progetto' };
    return this.parsedSteps.map(s => labels[s.type] ?? s.type);
  }

  @computed('currentStepIndex', 'totalSteps')
  get progressPercent() {
    if (!this.totalSteps) return 0;
    return Math.round((this.currentStepIndex / this.totalSteps) * 100);
  }

  @(task(function* () {
    yield timeout(500);
    // bootstrapSession handles access_token auth before this runs
  }).restartable())
  loadDataTask;

  @action
  nextStep() {
    set(this, 'step', this.currentStepIndex + 1);
  }

  @action
  prevStep() {
    const prev = this.currentStepIndex - 1;
    if (prev >= 0) {
      set(this, 'step', prev);
    }
  }

  @(task(function* () {
    this.session.logout();
    yield this.router.transitionTo('checkin');
  }).drop())
  newRegistrationTask;
}
